export default __webpack_public_path__ + "static/media/group-7365.c8bac3c6.svg";